module.exports = __webpack_public_path__ + "static/media/mug.df86198c.JPG";